<script setup lang="ts">
import type { ChatDividerProps } from "./chat.types";
import { useChatDivider } from "./useChatDivider";

defineOptions({ name: "EChatDivider" });

const props = defineProps<ChatDividerProps>();
const { classes } = useChatDivider({ props });
</script>

<template>
  <div :class="classes" class="e-chat-divider" part="divider">
    <span><slot /></span>
  </div>
</template>

<style>
:host {
  display: contents;
}
</style>
